import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./context/AuthContext";
import Navbar from "./components/Navbar";
import BuyerOnboarding from "./components/BuyerOnboarding";
import Hero from "./components/Hero";
import HowItWorks from "./components/Howitworks";
import About from "./components/About";
// import Carousel from "./components/Carousel";
import Footer from "./components/Footer";
import PublicRFQFeed from "./components/PublicRFQFeed";
import Login from "./pages/Login";
import SignUp from "./pages/SignUp";
import ForgotPassword from "./pages/ForgotPassword";
import MyRFQs from "./pages/MyRFQs";
import MyResponses from "./pages/MyResponses";
import CreateRFQ from "./pages/CreateRFQ";
import MarketFeed from "./pages/MarketFeed";
import RFQDetails from "./pages/RFQDetails";
import SubmitQuote from "./pages/SubmitQuote";
import QuoteResponses from "./pages/QuoteResponses";
import Chat from "./pages/Chat";
import Profile from "./pages/Profile";
import SupplierCommunicationHub from "./components/SupplierCommunicationHub";
import SupplierDashboard from "./components/SupplierDashboard";
import BuyerDashboard from "./components/BuyerDashboard";
import AdminDashboard from "./components/AdminDashboard";
import "./index.css";

// Protected Route Component
const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();
  
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-CC5500"></div>
      </div>
    );
  }
  
  return user ? children : <Navigate to="/login" />;
};

// Role-based redirect component
const RoleBasedRedirect = () => {
  const { user, userProfile, loading, getDashboardPath } = useAuth();
  
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-CC5500"></div>
      </div>
    );
  }
  
  if (!user) {
    return <Navigate to="/login" />;
  }
  
  const dashboardPath = getDashboardPath();
  return <Navigate to={dashboardPath} />;
};

// Landing Page Component
const LandingPage = () => (
  <BuyerOnboarding />
);

// Traditional Landing Page Component
const TraditionalLandingPage = () => (
  <>
    <Navbar />
    <main className="pt-16 lg:pt-20">
      <Hero />
      <PublicRFQFeed />
      <HowItWorks />
      <About />
      {/* <Carousel /> */}
    </main>
    <Footer />
  </>
);

// Main App Component
const AppContent = () => {
  const { user } = useAuth();

  return (
    <div className="App">
      <Routes>
        {/* Public Routes */}
        <Route path="/" element={user ? <RoleBasedRedirect /> : <LandingPage />} />
        <Route path="/home" element={<TraditionalLandingPage />} />
        <Route path="/login" element={user ? <RoleBasedRedirect /> : <Login />} />
        <Route path="/signup" element={<SignUp />} />
        <Route path="/forgot-password" element={user ? <RoleBasedRedirect /> : <ForgotPassword />} />
        <Route path="/rfq/:rfqId" element={<RFQDetails />} />
        <Route path="/market-feed" element={<MarketFeed />} />
        <Route path="/create-rfq" element={<CreateRFQ />} />
        <Route path="/submit-quote/:rfqId" element={<SubmitQuote />} />
        
        {/* Protected Routes */}
        <Route path="/dashboard" element={
          <ProtectedRoute>
            <AdminDashboard />
          </ProtectedRoute>
        } />

        <Route path="/my-rfqs" element={
          <ProtectedRoute>
            <MyRFQs />
          </ProtectedRoute>
        } />
        <Route path="/my-responses" element={
          <ProtectedRoute>
            <MyResponses />
          </ProtectedRoute>
        } />
        <Route path="/quotes/:rfqId" element={
          <ProtectedRoute>
            <QuoteResponses />
          </ProtectedRoute>
        } />
        <Route path="/chat" element={
          <ProtectedRoute>
            <Chat />
          </ProtectedRoute>
        } />
        <Route path="/communication-hub" element={
          <ProtectedRoute>
            <SupplierCommunicationHub />
          </ProtectedRoute>
        } />
        <Route path="/supplier-dashboard" element={
          <ProtectedRoute>
            <SupplierDashboard />
          </ProtectedRoute>
        } />
        <Route path="/buyer-dashboard" element={
          <ProtectedRoute>
            <BuyerDashboard />
          </ProtectedRoute>
        } />
        <Route path="/profile" element={
          <ProtectedRoute>
            <Profile />
          </ProtectedRoute>
        } />
      </Routes>
    </div>
  );
};

function App() {
  return (
    <Router>
      <AuthProvider>
        <AppContent />
      </AuthProvider>
    </Router>
  );
}

export default App;
